import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgChatBubbleWindow = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 80 80",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M44.5074471,27.8026741 C44.182457,28.4658851 44,29.211635 44,30 C44,32.7614237 46.2385763,35 49,35 C49.9758818,35 50.886465,34.7204238 51.6560244,34.2369967 C52.5163942,35.9738177 53,37.9304328 53,40 C53,47.1797017 47.1797017,53 40,53 C32.8202983,53 27,47.1797017 27,40 C27,32.8202983 32.8202983,27 40,27 C41.5846973,27 43.1031686,27.283547 44.5074471,27.8026741 Z M49,33 C47.3431458,33 46,31.6568542 46,30 C46,28.3431458 47.3431458,27 49,27 C50.6568542,27 52,28.3431458 52,30 C52,31.6568542 50.6568542,33 49,33 Z" })
});
export default SvgChatBubbleWindow;
